import {
  FETCH_EVENT_DETAILS_REQUEST,
  FETCH_EVENT_DETAILS_SUCCESS,
  FETCH_EVENT_DETAILS_FAILURE,
  RESET_EVENTS_STATE,
} from '../../../types/event';

const initialState = {
  loading: false,
  event: null,
  error: null,
  success: false,
};

const fetchEventDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENT_DETAILS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null,
        success: false,
      });

    case FETCH_EVENT_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        event: action.payload,
        success: true,
      });

    case FETCH_EVENT_DETAILS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
        success: false,
      });

    case RESET_EVENTS_STATE:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default fetchEventDetailsReducer;
